import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import TextareaCount from '../../Common/TextareaCount/TextareaCount';
import ConstantsList from '../../Common/Constants/Constants';
import Dropzone from 'react-dropzone';
import ImageCropperWrapper from '../../Common/ImageCropperWrapper/ImageCropperWrapper';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import camera from '../../../images/icons/camera.svg';
import deleteIcon from '../../../images/icons/delete.svg';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FlexpassForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posters: [],
            advertisement: [],
            showPosterLightbox: false,
            showPosterPreview: false,
            posterPreview: "",
            posterBlob: "",
            croppedPoster: null,
            showAdLightbox: false,
            showAdPreview: false,
            adPreview: "",
            adBlob: "",
            croppedAd: null,
            videos: [],
        }
        this.posterFilesUpdate;
        this.adFilesUpdate;
    }

    /* poster */

    renderPosterCropper = () => {
        let preview = (this.state.posterBlob) ? this.state.posterBlob.preview : "";
        let posterCropper = 
        <Modal className="modal-lg" isOpen={this.state.showPosterLightbox} toggle={this.togglePosterLightbox}>
            <ModalHeader toggle={this.togglePosterLightbox}>{strings.cropTitle}</ModalHeader>
            <ModalBody>
                <ImageCropperWrapper 
                    imgSrc={preview}
                    updateImagePreview={this.updatePosterPreview}
                />
            </ModalBody>
            <ModalFooter>
                <button 
                    type="submit" 
                    className="showtix-button showtix-background__primary-3"
                    onClick={this.onPosterButtonClick}>
                    {strings.cropButton}
                </button>
            </ModalFooter>
        </Modal>;
        return posterCropper;
    }

    onPosterButtonClick = () => {
        this.setState({
            posters: this.posterFilesUpdate,
            showPosterLightbox: false,
            showPosterPreview: true
        });
        this.props.uploadFile(this.state.posterBlob, 'poster', this.state.croppedPoster);
    }

    togglePosterLightbox = () => {
        this.setState({
            showPosterLightbox: !this.state.showPosterLightbox
        });
    }

    updatePosterPreview = (imageUrl, croppedImage) => {
        this.setState({
            posterPreview: imageUrl,
            croppedPoster: croppedImage
        });
    }

    dropPoster = (filesUpdate) => {
        let posterBlob = (filesUpdate[0] instanceof Blob) ? filesUpdate[0] : "";

        this.setState({
            posterBlob,
            showPosterLightbox: true,
            showPosterPreview: false
        });
    }

    /* ad */

    renderAdCropper = () => {
        let preview = (this.state.adBlob) ? this.state.adBlob.preview : "";
        let adCropper = 
        <Modal className="modal-lg" isOpen={this.state.showAdLightbox} toggle={this.toggleAdLightbox}>
            <ModalHeader toggle={this.toggleAdLightbox}>{strings.cropTitle}</ModalHeader>
            <ModalBody>
                <ImageCropperWrapper 
                    imgSrc={preview}
                    updateImagePreview={this.updateAdPreview}
                    ratio={7.5 / 1.5}
                    width={400}
                />
            </ModalBody>
            <ModalFooter>
                <button 
                    type="submit" 
                    className="showtix-button showtix-background__primary-3"
                    onClick={this.onAdButtonClick}>
                    {strings.cropButton}
                </button>
            </ModalFooter>
        </Modal>;
        return adCropper;
    }

    onAdButtonClick = () => {
        this.setState({
            posters: this.adFilesUpdate,
            showAdLightbox: false,
            showAdPreview: true
        });
        this.props.uploadFile(this.state.adBlob, 'advertisement', this.state.croppedAd);
    }

    toggleAdLightbox = () => {
        this.setState({
            showAdLightbox: !this.state.showAdLightbox
        });
    }

    updateAdPreview = (imageUrl, croppedImage) => {
        this.setState({
            adPreview: imageUrl,
            croppedAd: croppedImage
        });
    }

    dropAdvertisement = (filesUpdate) => {
        let adBlob = (filesUpdate[0] instanceof Blob) ? filesUpdate[0] : "";

        this.setState({
            adBlob,
            showAdLightbox: true,
            showAdPreview: false
        });
    }

    /* shared */

    clearFile = (e) => {
        e.stopPropagation();

        this.setState({
            [e.target.getAttribute('showtoclear')]: false,
            [e.target.getAttribute('postertoclear')]: "",
            [e.target.getAttribute('previewtoclear')]: ""
        });
        this.props.clearFile(e);
    }

    componentDidMount() {
        this.getAdminVideos();
    }

    getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

    render() {
        let poster = this.props.flexpassDetails.details.poster;
        let advertisement = this.props.flexpassDetails.details.advertisement;
        const videos = this.state.videos;
		let videoUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
        videos.forEach((video) => {
            if (video.title.includes('Flex Pass')) {
                videoUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
			}
        });
        return ( 
            <div className="showtix-flexpass-form">
                <div className="showtix-section showtix-section__padding-1">
                    <div className="container">
                        <div className="row">
                            <div className="col-12"><h1>{strings.title}</h1></div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-lg-8">
                                <div className="row">
                                    <div className="col-12 col-lg-6 order-1 order-lg-1">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="flexName">
                                                {strings.form.name} *
                                            </label>
                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="text"
                                                    id="flexName"
                                                    name="flexName"
                                                    object="details"
                                                    validation="(^(?!\s*$).+)"
                                                    value={this.props.flexpassDetails.details.flexName}
                                                    onChange={this.props.handleChange}
                                                    onBlur={this.props.validateRequiredField}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {!this.props.validation.details.flexName.valid &&
                                            <div className="showtix-note error">
                                                {this.props.validation.details.flexName.msg}
                                            </div>
                                        }
                                    </div>

                                    <div className="col-12 col-lg-6 order-4 order-lg-2">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="contactEmail">
                                                {strings.form.email} *
                                                <span id="tooltip-contactEmail" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-contactEmail">
                                                    {strings.form.emailTooltip}
                                                </Tooltip>
                                            </label>

                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="email"
                                                    id="contactEmail"
                                                    name="contactEmail"
                                                    object="details"
                                                    validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                                    value={this.props.flexpassDetails.details.contactEmail}
                                                    onChange={this.props.handleChange}
                                                    onBlur={this.props.validateRequiredField}
                                                />
                                            </div>
                                            {!this.props.validation.details.contactEmail.valid &&
                                                <div className="showtix-note error">
                                                    {this.props.validation.details.contactEmail.msg}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                
                                    <div className="col-12 col-lg-6 order-2 order-lg-3">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="flexShortName">
                                                {strings.form.shortName}
                                            </label>
                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="text"
                                                    id="flexShortName"
                                                    name="flexShortName"
                                                    object="details"
                                                    value={this.props.flexpassDetails.details.flexShortName}
                                                    onChange={this.props.handleChange}
                                                    onBlur={this.props.validateRequiredField}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6 order-5">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="contactPhone">
                                                {strings.form.phone} *
                                                <span id="tooltip-contactPhone" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-contactPhone">
                                                    {strings.form.phoneTooltip}
                                                </Tooltip>
                                            </label>

                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="tel"
                                                    object="details"
                                                    id="contactPhone" 
                                                    name="contactPhone" 
                                                    validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
                                                    value={this.props.flexpassDetails.details.contactPhone}
                                                    onChange={this.props.handleChange}
                                                    onBlur={this.props.validateRequiredField}
                                                />
                                            </div>
                                            {!this.props.validation.details.contactPhone.valid &&
                                                <div className="showtix-note error">
                                                    {this.props.validation.details.contactPhone.msg}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 order-3 order-lg-5">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="flexDescription">
                                                {strings.form.description.label}
                                            </label>

                                            <TextareaCount
                                                maxLength="150"
                                                id="flexDescription"
                                                name="flexDescription"
                                                object="details"
                                                value={this.props.flexpassDetails.details.flexDescription}
                                                handleChange={this.props.handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6 order-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="flexWebsite">
                                                {strings.form.website}
                                            </label>
                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="text"
                                                    id="flexWebsite"
                                                    name="flexWebsite"
                                                    object="details"
                                                    value={this.props.flexpassDetails.details.flexWebsite}
                                                    onChange={this.props.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label">{strings.form.serviceFee.label} *</label>
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="serviceFee-client"
                                                    name="serviceFee"
                                                    object="details"
                                                    value="true"
                                                    radioname="client"
                                                    onChange={this.props.handleChange}
                                                    checked={this.props.flexpassDetails.details.serviceFee === "client"}
                                                />
                                                <label className="showtix-label" htmlFor="serviceFee-client">{strings.form.serviceFee.client}</label>
                                            </div>

                                            <div className="showtix-form__radio">
                                                <input 
                                                    type="radio" 
                                                    className="showtix-input" 
                                                    id="serviceFee-customer"
                                                    name="serviceFee"
                                                    object="details"
                                                    value="false"
                                                    radioname="customer"
                                                    onChange={this.props.handleChange}
                                                    checked={this.props.flexpassDetails.details.serviceFee !== "client"}
                                                /> 
                                                <label className="showtix-label" htmlFor="serviceFee-customer">{strings.form.serviceFee.customer}</label>
                                            </div>
                                        </div>            
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="flexQuantityToPurchase">
                                                {strings.form.flexQuantityToPurchase} *
                                                <span id="tooltip-flexQuantityToPurchase" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-flexQuantityToPurchase">
                                                    {strings.form.flexQuantityToPurchaseTooltip}
                                                </Tooltip>
                                            </label>
                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="number"
                                                    id="flexQuantityToPurchase"
                                                    name="flexQuantityToPurchase"
                                                    object="details"
                                                    value={this.props.flexpassDetails.details.flexQuantityToPurchase}
                                                    validation={ConstantsList.REGEX.NUMBERS_ONLY}
                                                    onChange={this.props.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="ticketsQuantityToRedeem">
                                                {strings.form.ticketsQuantityToRedeem} *
                                                <span id="tooltip-ticketsQuantityToRedeem" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-ticketsQuantityToRedeem">
                                                    {strings.form.ticketsQuantityToRedeemTooltip}
                                                </Tooltip>
                                            </label>

                                            <div className="showtix-form__input">
                                                <input
                                                    className="showtix-input"
                                                    type="number"
                                                    id="ticketsQuantityToRedeem"
                                                    name="ticketsQuantityToRedeem"
                                                    object="details"
                                                    value={this.props.flexpassDetails.details.ticketsQuantityToRedeem}
                                                    validation={ConstantsList.REGEX.NUMBERS_ONLY}
                                                    onChange={this.props.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label">{strings.form.poster.label}
                                                <span id="tooltip-poster" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-poster">
                                                    {strings.form.poster.tooltip}
                                                </Tooltip>
                                            </label>

                                            <div className="showtix-form__drop">
                                                <Dropzone
                                                    className="showtix-dropzone"
                                                    onDrop={this.dropPoster}
                                                    accept="image/jpeg, image/png, image/gif"
                                                    maxSize={1000000}
                                                    multiple={false}>
                                                    <div className="showtix-dropzone__title">{strings.form.dragAndDropImages}</div>
                                                    <img src={camera} alt="Upload file for Poster" />
                                                    <div className="showtix-dropzone__file">
                                                        {this.state.showPosterPreview &&
                                                            <div className="showtix-dropzone__file__content">
                                                                <img 
                                                                    className="delete-icon" 
                                                                    src={deleteIcon} 
                                                                    alt="delete icon" 
                                                                    objectname="poster"
                                                                    postertoclear="posterBlob"
                                                                    previewtoclear="posterPreview"
                                                                    showtoclear="showPosterPreview"
                                                                    onClick={this.clearFile}  
                                                                />
                                                                <div><span>{this.state.posterBlob.name} - {this.state.posterBlob.size} bytes</span></div>
                                                                <img src={this.state.posterPreview} className="showtix-dropzone__preview" alt="poster preview" />
                                                            </div>
                                                        }
                                                    </div>
                                                </Dropzone>
                                                { this.renderPosterCropper() }
                                            </div>
                                            { this.props.flexpassDetails.details.poster_graphic_url &&
                                                <div className="showtix-event-image">
                                                    <img src={this.props.flexpassDetails.details.poster_graphic_url || ''} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label">{strings.form.advertisement.label}
                                                <span id="tooltip-advertisement" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-advertisement">
                                                    {strings.form.advertisement.tooltip}
                                                </Tooltip>
                                            </label>

                                            <div className="showtix-form__drop">
                                                <Dropzone
                                                    className="showtix-dropzone"
                                                    onDrop={this.dropAdvertisement}
                                                    accept="image/jpeg, image/png, image/gif"
                                                    maxSize={1000000}
                                                    multiple={false}>
                                                    <div className="showtix-dropzone__title">{strings.form.dragAndDropImages}</div>
                                                    <img src={camera} alt="Upload file for Advertisement" />
                                                    <div className="showtix-dropzone__file">
                                                    {this.state.showAdPreview &&
                                                        <div className="showtix-dropzone__file__content">
                                                            <img 
                                                                className="delete-icon" 
                                                                src={deleteIcon} 
                                                                alt="delete icon" 
                                                                objectname="dropAdvertisement" 
                                                                postertoclear="adBlob"
                                                                previewtoclear="adPreview"
                                                                showtoclear="showAdPreview"
                                                                onClick={this.clearFile}  
                                                            />
                                                            <div><span>{this.state.adBlob.name} - {this.state.adBlob.size} bytes</span></div>
                                                            <img src={this.state.adPreview} className="showtix-dropzone__preview" alt="ad preview" />
                                                        </div>
                                                    }
                                                    </div>
                                                </Dropzone>
                                                { this.renderAdCropper() }
                                            </div>
                                            { this.props.flexpassDetails.details.ad_graphic_url &&
                                                <div className="showtix-event-image">
                                                    <img src={this.props.flexpassDetails.details.ad_graphic_url || ''} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            { strings.help &&
                            <div className="col-12 col-lg-4">
                                <div className="showtix-box">
                                    <div className="showtix-padder">
                                        <h3 className="showtix-box__title">{strings.video.title}</h3>
                                        <p><a href={videoUrl} target="_blank" rel="noopener">{strings.video.content1}</a></p>
                                    </div>	
                                </div>
                                <Help help={strings.help} />
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

FlexpassForm.propTypes = {
    validation: PropTypes.shape({
        details: PropTypes.shape({
            flexName: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            contactEmail: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            contactPhone: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
        })
    }),
    flexpassDetails: PropTypes.shape({
        details: PropTypes.shape({
            serviceFee: PropTypes.string
        })
    }),
    uploadFile: PropTypes.func,
    handleChange: PropTypes.func,
    validateRequiredField: PropTypes.func,
}
 
export default FlexpassForm;


// WEBPACK FOOTER //
// ./src/components/CreateFlexpass/FlexpassForm/FlexpassForm.js